/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../js/global";
	import * as helper from "../../js/helper";
	import property_form from "../components/property-form.vue";
	import full_loading from "../components/full-loading.vue";
	const __vue_script__ ={
        components: {
            property_form:property_form,
            full_loading:full_loading,
        },
		name:'add_property_widget',
        props: {
            property_json: {
				type: String,
            },
            property_name: {
				type: String,
            },
            mashro_json: {
				type: String,
            }
        },
		data() {
			return {
                global,
                helper,
                frappe,
				ready:false,
				loading:false,
				agreement:null,
                policy_agreed:false,
				current_step: 0,
				parent_property: new global.Property(),
				child_property:null,
				property_types:global.property_constants.property_types,
				permitted_agencies:[], 
                edit_property: null,
                mashro: null,
				is_nafath_verified:false,
				ad_license_number: "",
				advertiser_id: null,
				borders:false,
				rer_borders:false,
			}
		},
        async created(){
			if(this.property_json != undefined){
                this.edit_property = JSON.parse(this.property_json);
				this.parent_property.from_map(this.edit_property);
			}
			this.parent_property.for_agency = 0;
			if(this.mashro_json != "None"){
                this.mashro = JSON.parse(this.mashro_json);
				this.parent_property.for_agency = 1;
				this.parent_property.selected_agency = this.mashro.user;
			}
			await this.initNafath();
    		this.parent_property.total_price = this.parent_property.total_price.toFixed(0);
        },
        async mounted(){
			global.emitter.emit("show-full-loading");
			await this.getPermittedAgencies();
			if(this.edit_property){
				this.normalizeRegaData();
				this.showModal("#rega_info_modal");
			}
			this.ready = true;
			global.emitter.emit("hide-full-loading");
        },
		methods: {
			select_property_type: function (selected_property_type){
				this.parent_property.property_type = selected_property_type;
				this.current_step = global.property_constants.property_with_child[selected_property_type]?2:3;
			},
			getPermittedAgencies: async function () {
				this.loading = true;
                let params = {};
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.get_permitted_agencies",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    this.permitted_agencies = res.message
                    this.loading = false
                    this.$forceUpdate();
                } catch (e) {
                    console.log("failed");
                    console.log(e);
                    var exceptions = helper.showException(e);
                }
                
                this.loading = false;
			},
			load_agreement: async function () {
				console.log("load_agreement")
				$("#save_dialog").modal('show');
				// if(this.edit_property){
				// 	this.save_property();
				// 	return;
				// }
				this.loading = true;
				let role = this.parent_property.creator_type;
                let params = {
					"role": role
				};
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.get_add_property_policy",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    this.agreement = res.message
                    this.loading = false
                    this.$forceUpdate();
                } catch (e) {
                    console.log("failed");
                    console.log(e);
                    var exceptions = helper.showException(e);
                }
                
                this.loading = false;
			},
			confirm_save: async function () {
				if(!this.parent_property.validate()){
					bootbox.alert({
						title: helper.t("Error"),
						message:`<div class="alert alert-danger" role="alert">
									`+helper.t("Please fix the issues marked in Red Color")+`
								</div>`,
						size: 'large',
						buttons: {
							ok: {
								label: helper.t("Ok"),
								className: 'btn default-btn'
							}
						},
						callback: (results) => results?this.save_property():console.log("cancel"),
					});
					return;
				}
				this.agreement=null;
				this.policy_agreed=false;
				$('#save_dialog').modal('show');
			},
            async initNafath(){
				this.is_nafath_verified = false;
                global.emitter.emit("show-full-loading");
				try {
					let params = {};
					let res = await $.ajax({
						headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
						url: "/api/method/maalek.api.is_nafath_verified",
						type: "GET",
						data: params,
					});
					if (res.message == false) {
                        this.is_nafath_verified = false;
					}else{
                        this.is_nafath_verified = true;
                    }
				} catch (error) {
					this.exceptions = helper.showException(error);
				}
                global.emitter.emit("hide-full-loading");
            },
            async checkAdvertisement(){
				console.log("checkAdvertisement");
                global.emitter.emit("show-full-loading");
				if(this.ad_license_number.length != 10){
					helper.showException("Wrong advertisement license number");
				}else{
					try {
						let params = {
							"ad_license_number":this.ad_license_number,
							"advertiser_id":this.advertiser_id,
							"for_agency": this.parent_property.for_agency,
							"selected_agency": this.parent_property.selected_agency
						};
						
						let res = await $.ajax({
							headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
							url: "/api/method/maalek.api.check_rega_advertisement_validator",
							type: "GET",
							data: params
						});
						if (this.advertiser_id != null) {
							global.emitter.emit("set-national-id",this.advertiser_id);
							global.emitter.emit("set-onsuccess-func",()=>{
								$('#nafaz-verification-modal').modal('hide');
								this.getRegaAdvertisement();
							});
							$('#nafaz-verification-modal').modal('show');
							global.emitter.emit("hide-full-loading");
						}else{
							this.getRegaAdvertisement();
							return;
						}
					} catch (error) {
						this.exceptions = helper.showException(error);
					}
				}
                global.emitter.emit("hide-full-loading");
            },
            async getRegaAdvertisement(){
				console.log("getRegaAdvertisement");
                global.emitter.emit("show-full-loading");
				try {
					let params = {
						"ad_license_number":this.ad_license_number,
						"for_agency": this.parent_property.for_agency,
						"selected_agency": this.parent_property.selected_agency,
					};
						
					if(this.mashro != null){
						params["selected_mashro"] = this.mashro.name
					}
					let res = await $.ajax({
						headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
						url: "/api/method/maalek.api.rega_advertisement_validator",
						type: "GET",
						data: params
					});
					this.parent_property.name = res.message.name;
					this.parent_property.ad_type = res.message.ad_type;
					this.parent_property.property_type = res.message.property_type;
					this.parent_property.size = res.message.size;
					this.parent_property.lat = res.message.lat;
					this.parent_property.lng = res.message.lng;
					this.parent_property.price_sqr_meter = res.message.price_sqr_meter;
					this.parent_property.total_price = res.message.total_price;
					this.parent_property.ad_license_number = res.message.ad_license_number;
					this.parent_property.rega_data = JSON.parse(res.message.rega_data);
					this.parent_property.creator_type = res.message.creator_type;
					this.normalizeRegaData();
					this.showModal("#rega_info_modal");
				} catch (error) {
					this.exceptions = helper.showException(error);
				}
                global.emitter.emit("hide-full-loading");
            },
			normalizeRegaData(){
				this.borders = false;
				this.rer_borders = false;
				for (const key in this.parent_property.rega_data["borders"]) {
					if(this.parent_property.rega_data["borders"][key] != null && this.parent_property.rega_data["borders"][key] != ""){
						this.borders = true;
					}
				}
				if(this.parent_property.rega_data["rerBorders"].length > 0){
					this.rer_borders = true;
				}
			},
            async reupdateRegaAdvertisement(){
                global.emitter.emit("show-full-loading");
				try {
					let params = {
						"property_name":this.parent_property.name,
					};
					let res = await $.ajax({
						headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
						url: "/api/method/maalek.api.reupdate_rega_advertisement",
						type: "GET",
						data: params
					});
					this.parent_property.lat = res.message.lat;
					this.parent_property.lng = res.message.lng;
					this.parent_property.size = res.message.size;
					this.parent_property.price_sqr_meter = res.message.price_sqr_meter;
					this.parent_property.total_price = res.message.total_price;
					this.parent_property.rega_data = JSON.parse(res.message.rega_data);
					this.normalizeRegaData();
					this.showModal("#rega_info_modal");
				} catch (error) {
					this.exceptions = helper.showException(error);
				}
                global.emitter.emit("hide-full-loading");
            },
			upload_files: async function(docname){
				return frappe.run_serially(
					this.parent_property.images.map(
						(image, i) =>
							() => helper.upload_file(image.file, i,"Property Detail",docname)
					)
				);
			},
			save_property: async function(){
				try {
					global.emitter.emit("show-full-loading");
					let params = this.parent_property;
					if( !Object.keys(global.property_constants.property_with_child).includes(this.property_type) ){
						console.log("clear floors")
						this.parent_property.floors = [];
					}else{
						console.log("keep floors")
					}
					let res = await $.ajax({
						headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
						url: "/api/method/maalek.api.add_property",
						type: "POST",
						data: JSON.stringify(params)
					});
					global.emitter.emit("hide-full-loading");
                    helper.showSuccess("Property Saved",()=>{
					location.replace("/account/my-properties");
					});
				} catch (e) {
					console.log(e);
					global.emitter.emit("hide-full-loading");
                    var exceptions = helper.showException(e);
				}
			},
			showModal: function(elementID){
				$(elementID).modal('show');
			},
			closeModal: function(elementID){
				$(elementID).modal('hide');
			},
			set_for_agency: function(val){
				this.parent_property.for_agency = val;
				if(this.parent_property.for_agency && this.permitted_agencies.length == 1){
					this.parent_property.selected_agency = this.permitted_agencies[0].agency;
					this.parent_property.selected_agency_full_name = this.permitted_agencies[0].full_name;
				}else if(!this.parent_property.for_agency){
					this.parent_property.selected_agency = "";
					this.parent_property.selected_agency_full_name = "";
				}
			}
		},
		computed:{
			save_btn_text(){
				if(this.parent_property.publish)
					return "Save & Publish Property"
				return "Save & Unpublish Property"
			}
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add_property_widget pb-5" },
    [
      _c("full_loading"),
      _vm._v(" "),
      _vm.ready
        ? _c("div", [
            _vm.edit_property == null &&
            _vm.parent_property.ad_type == "" &&
            _vm.parent_property.property_type == ""
              ? _c(
                  "div",
                  [
                    !_vm.mashro
                      ? [
                          _vm.permitted_agencies.length > 0
                            ? _c(
                                "div",
                                { staticClass: "form-group text-center" },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t(
                                          "Advertisement belongs to whom?"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-group me-2",
                                      attrs: { role: "group" }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn",
                                          class: !_vm.parent_property.for_agency
                                            ? "btn-primary"
                                            : "btn-outline-secondary",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.set_for_agency(0)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.helper.t("For Yourself")
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn",
                                          class: _vm.parent_property.for_agency
                                            ? "btn-primary"
                                            : "btn-outline-secondary",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.set_for_agency(1)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.helper.t("For Agency")
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.permitted_agencies.length > 1 &&
                          _vm.parent_property.for_agency
                            ? _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-lg-6 col-md-6" },
                                    [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.parent_property
                                                    .selected_agency,
                                                expression:
                                                  "parent_property.selected_agency"
                                              }
                                            ],
                                            staticClass:
                                              "form-select form-control border-radius",
                                            attrs: {
                                              "aria-label":
                                                "Default select example"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.parent_property,
                                                  "selected_agency",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.helper.t(
                                                      "Select Agency"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.permitted_agencies,
                                              function(agency) {
                                                return _c(
                                                  "option",
                                                  {
                                                    domProps: {
                                                      value: agency.agency
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(agency.full_name) +
                                                        " - (0" +
                                                        _vm._s(
                                                          agency.agency.substring(
                                                            4
                                                          )
                                                        ) +
                                                        ")"
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mashro
                      ? _c("h3", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(_vm.helper.t("Add Unit to Project")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mashro
                      ? _c("h5", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(_vm.mashro.title))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.is_nafath_verified && !_vm.parent_property.for_agency
                      ? _c(
                          "div",
                          { staticClass: "row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-lg-4 col-sm-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.helper.t("National Id / Iqama"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.advertiser_id,
                                      expression: "advertiser_id"
                                    }
                                  ],
                                  staticClass: "form-control border-radius",
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.advertiser_id },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.advertiser_id = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ])
                          ]
                        )
                      : _vm.parent_property.selected_agency
                      ? _c(
                          "div",
                          { staticClass: "row justify-content-center" },
                          [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "h5",
                                {
                                  staticClass: "modal-title text-center",
                                  attrs: { id: "staticBackdropLabel" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.parent_property
                                        .selected_agency_full_name
                                    )
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-lg-4 col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.helper.t("Ad License Number")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.ad_license_number,
                                expression: "ad_license_number"
                              }
                            ],
                            staticClass: "form-control border-radius",
                            attrs: { type: "text" },
                            domProps: { value: _vm.ad_license_number },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.ad_license_number = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row d-flex justify-content-center" },
                      [
                        _c("div", { staticClass: "col-lg-4 text-center" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn default-btn mt-2 show-hand",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.checkAdvertisement()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.helper.t("Continue")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.edit_property != null ||
            (_vm.parent_property.ad_type != "" &&
              _vm.parent_property.property_type != "")
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c("h2", { staticClass: "text-start" }, [
                            _vm._v(
                              _vm._s(
                                _vm.helper.t(
                                  "{0} for " + _vm.parent_property.ad_type,
                                  [_vm.parent_property.property_type]
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 d-flex justify-content-end" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "text-end show-hand mx-3",
                                on: {
                                  click: function($event) {
                                    return _vm.reupdateRegaAdvertisement()
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-rotate fa-lg mx-1"
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.helper.t("Reupdate from REGA")) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "text-end show-hand mx-3",
                                attrs: {
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-placement": "top",
                                  title: _vm.helper.t("Full property info.")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showModal("#rega_info_modal")
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-solid fa-circle-info fa-lg mx-1"
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.helper.t("Ad license ID: {0}", [
                                        _vm.parent_property.ad_license_number
                                      ])
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("property_form", {
                      attrs: {
                        property: _vm.parent_property,
                        is_edit: _vm.edit_property != null ? true : false
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.parent_property.ad_type != "" &&
            _vm.parent_property.property_type != ""
              ? _c("div", { staticClass: "col-lg-12 text-center mt-20" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn default-btn",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.load_agreement()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("Continue")))]
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade filter-popup-area",
          attrs: {
            id: "save_dialog",
            "data-bs-keyboard": "false",
            tabindex: "-1",
            "aria-labelledby": "staticBackdropLabel",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t(!_vm.agreement ? "Details" : "Agreement")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.edit_property == null && !_vm.agreement
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group mb-3" }, [
                            _c(
                              "label",
                              {
                                staticClass: "toggler",
                                attrs: { id: "filt-yearly" }
                              },
                              [_vm._v(_vm._s(_vm.helper.t("Advertising as")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-toolbar",
                                attrs: {
                                  role: "toolbar",
                                  "aria-label": "Toolbar with button groups"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group me-2",
                                    attrs: { role: "group" }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn",
                                        class:
                                          _vm.parent_property.creator_type ==
                                          "Owner"
                                            ? "btn-primary"
                                            : "btn-outline-secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.parent_property.creator_type =
                                              "Owner"
                                            _vm.parent_property.for_agency = false
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("As an Owner"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn",
                                        class:
                                          _vm.parent_property.creator_type ==
                                          "Agent"
                                            ? "btn-primary"
                                            : "btn-outline-secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.parent_property.creator_type =
                                              "Agent"
                                            _vm.parent_property.for_agency = false
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("As an Agent"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn",
                                        class:
                                          _vm.parent_property.creator_type ==
                                          "Advertiser"
                                            ? "btn-primary"
                                            : "btn-outline-secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.parent_property.creator_type =
                                              "Advertiser"
                                            _vm.parent_property.for_agency = false
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helper.t("As an Advertiser")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.edit_property == null &&
                  _vm.permitted_agencies.length > 0 &&
                  !_vm.agreement &&
                  ["Owner", "Advertiser"].includes(
                    _vm.parent_property.creator_type
                  )
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group mb-3" }, [
                            _c(
                              "label",
                              {
                                staticClass: "toggler",
                                attrs: { id: "filt-yearly" }
                              },
                              [_vm._v(_vm._s(_vm.helper.t("Advertising For")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-toolbar",
                                attrs: {
                                  role: "toolbar",
                                  "aria-label": "Toolbar with button groups"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group me-2",
                                    attrs: { role: "group" }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn",
                                        class: !_vm.parent_property.for_agency
                                          ? "btn-primary"
                                          : "btn-outline-secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.parent_property.for_agency = 0
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("Not for agency"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.permitted_agencies.length > 0
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn",
                                            class: _vm.parent_property
                                              .for_agency
                                              ? "btn-primary"
                                              : "btn-outline-secondary",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                _vm.parent_property.for_agency = 1
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.helper.t("For agency"))
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.agreement
                    ? _c("div", { staticClass: "row add-listing" }, [
                        _c("div", {
                          staticStyle: {
                            padding: "10px",
                            background: "lightgrey",
                            border: "2px grey SOLID",
                            height: "300px",
                            overflow: "auto"
                          },
                          domProps: { innerHTML: _vm._s(_vm.agreement) }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "features-content mt-2 text-center" },
                          [
                            _c(
                              "ul",
                              { staticClass: "d-flex justify-content-center" },
                              [
                                _c(
                                  "li",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.policy_agreed = !_vm.policy_agreed
                                      }
                                    }
                                  },
                                  [
                                    _vm.policy_agreed
                                      ? _c("i", {
                                          staticClass: "ri-checkbox-circle-fill"
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "ri-checkbox-blank-circle-line"
                                        }),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.helper.t("I agree")) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.policy_agreed
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn default-btn equalizer",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.save_property()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.edit_property == null
                                            ? _vm.helper.t(
                                                _vm.parent_property.publish
                                                  ? "Save & publish property"
                                                  : "Save & unpublish property"
                                              )
                                            : _vm.helper.t(
                                                _vm.parent_property.publish
                                                  ? "Update & publish property"
                                                  : "Update & unpublish property"
                                              )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      !_vm.agreement
                        ? [
                            _vm.edit_property == null &&
                            !_vm.parent_property.for_agency
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.helper.t("{0} for {1} as an {2}", [
                                        this.parent_property.property_type,
                                        this.parent_property.ad_type,
                                        _vm.parent_property.creator_type
                                      ])
                                    )
                                  )
                                ])
                              : _vm.edit_property == null &&
                                _vm.parent_property.for_agency
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.helper.t(
                                        "{0} for {1} for an Agency as an {2}",
                                        [
                                          this.parent_property.property_type,
                                          this.parent_property.ad_type,
                                          _vm.parent_property.creator_type
                                        ]
                                      )
                                    )
                                  )
                                ])
                              : _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.helper.t("Do you want to update?")
                                    )
                                  )
                                ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col show-hand text-end" }, [
                        !_vm.agreement &&
                        (!_vm.parent_property.for_agency ||
                          _vm.parent_property.selected_agency)
                          ? _c(
                              "a",
                              {
                                staticClass: "btn default-btn mt-2",
                                on: {
                                  click: function($event) {
                                    return _vm.load_agreement()
                                  }
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.helper.t(
                                        _vm.edit_property == null
                                          ? "Continue"
                                          : "Update"
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn default-btn show-hand mt-2",
                            on: {
                              click: function($event) {
                                return _vm.closeModal("#save_dialog")
                              }
                            }
                          },
                          [_c("p", [_vm._v(_vm._s(_vm.helper.t("No wait!")))])]
                        )
                      ])
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade filter-popup-area",
          attrs: {
            id: "rega_info_modal",
            "data-bs-keyboard": "false",
            tabindex: "-1",
            "aria-labelledby": "staticBackdropLabel",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("Full property info.")))]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("table", { staticClass: "table table-striped" }, [
                        _c(
                          "tbody",
                          _vm._l(_vm.parent_property.rega_data, function(
                            val,
                            atr
                          ) {
                            return val != undefined &&
                              val != null &&
                              val !== "" &&
                              atr != "adLicenseUrl" &&
                              atr != "adSource" &&
                              atr != "location" &&
                              atr != "locationDescriptionOnMOJDeed" &&
                              atr != "propertyPrice" &&
                              atr != "landTotalPrice" &&
                              atr != "landTotalAnnualRent" &&
                              (_vm.borders || atr != "borders") &&
                              (_vm.rer_borders || atr != "rerBorders")
                              ? _c("tr", [
                                  atr == "propertyPrice"
                                    ? _c(
                                        "td",
                                        [
                                          _vm.parent_property.ad_type == "Sale"
                                            ? [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.parent_property
                                                        .property_type == "Land"
                                                        ? _vm.helper.t(
                                                            "Price per Square Meter"
                                                          )
                                                        : _vm.helper.t(
                                                            "Total Price"
                                                          )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.parent_property
                                                        .property_type == "Land"
                                                        ? _vm.helper.t(
                                                            "Yearly rent per Square Meter"
                                                          )
                                                        : _vm.helper.t(
                                                            "Yearly Rent"
                                                          )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    : _c("td", [
                                        _vm._v(_vm._s(_vm.helper.t(atr)))
                                      ]),
                                  _vm._v(" "),
                                  atr == "borders" || atr == "location"
                                    ? _c("td", [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table table-striped table-sm text-break"
                                          },
                                          [
                                            _c(
                                              "tbody",
                                              _vm._l(val, function(sval, satr) {
                                                return sval != undefined &&
                                                  sval != null &&
                                                  sval != ""
                                                  ? _c("tr", [
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.helper.t(satr)
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.helper.t(sval)
                                                          )
                                                        )
                                                      ])
                                                    ])
                                                  : _vm._e()
                                              }),
                                              0
                                            )
                                          ]
                                        )
                                      ])
                                    : atr == "rerBorders"
                                    ? _c("td", [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table table-striped table-sm table-borderless"
                                          },
                                          _vm._l(val, function(sval, satr) {
                                            return sval != undefined &&
                                              sval != null &&
                                              sval != ""
                                              ? _c("tr", [
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.helper.t(
                                                            "_direction"
                                                          )
                                                        ) + ": "
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(sval.direction)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.helper.t("_type")
                                                        ) + ": "
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      " " + _vm._s(sval.type)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.helper.t(
                                                            "_length"
                                                          )
                                                        ) + ": "
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      " " + _vm._s(sval.length)
                                                    )
                                                  ])
                                                ])
                                              : _vm._e()
                                          }),
                                          0
                                        )
                                      ])
                                    : _c("td", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.helper.t(val)) +
                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                ])
                              : _vm._e()
                          }),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col show-hand text-end" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn default-btn mt-2 show-hand",
                          on: {
                            click: function($event) {
                              return _vm.closeModal("#rega_info_modal")
                            }
                          }
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.helper.t("Continue")))])]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3a660fdc_0", { source: "\n#app {\r\n\ttext-align: center;\r\n\tcolor: #2c3e50;\r\n\tmargin-top: 60px;\n}\n.single-pricing .default-btn{\r\n\tmargin-bottom: unset;\n}\n.features-content ul *{\r\n\tcursor: pointer;\n}\n.pricing-switch{\r\n\tmargin-bottom: 0;\r\n\tmargin-top: 10px;\r\n\ttext-align: start;\n}\n.pricing-switch .toggler{\r\n\tmargin-top: 10px;\n}\n.accordion-item .accordion-body ul li::before {\r\n    display: none;\n}\n.features-content *{\r\n\tuser-select: none;\n}\n.floor-table{\r\n\tborder-right: SOLID 2px #014116;\n}\n.floor-table h3{\r\n\tfont-size: 1.2rem;\n}\n.floor-table .actions *{\r\n\tcolor: #014116;\n}\n.floor-row:hover{\r\n\tbackground-color: aliceblue;\n}\n.show-on-hover, .show-on-hover-child{\r\n\tcursor: pointer;\n}\n.floor-row .show-on-hover{\r\n\tdisplay: none;\n}\n.floor-row:hover .show-on-hover{\r\n\tdisplay: block;\n}\n.property-div{\r\n\tborder-bottom: SOLID 1px antiquewhite;\n}\n.property-div.error{\r\n\tborder: SOLID 1px red;\r\n    background-color: rgba(255, 0, 0, 0.1215686275) !important;\n}\n.property-div .show-on-hover-child{\r\n\tdisplay: none;\n}\n.property-div:hover{\r\n\tbackground-color: antiquewhite;\n}\n.property-div:hover .show-on-hover-child{\r\n\tdisplay: block;\n}\n.tags{\r\n\tcursor: pointer;\n}\n.tags:hover{\r\n\tbackground-color: #014116;\n}\n.tags:hover *{\r\n\tcolor: #fff;\n}\n.tags span{\r\n\tborder: SOLID 2px;\r\n    padding: 5px;\n}\n.tags ul{\r\n    padding: 5px !important;\n}\n.tags ul li{\r\n\tpadding-left: 5px !important;\r\n    display: inline-block !important;\n}\n.modal-dialog{\r\n\t/* max-width: 70% !important; */\n}\n.add_property_widget{\r\n\tposition: relative;\n}\n.modal-content {\r\n  overflow: auto !important;\n}\r\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/add-property-widget.vue"],"names":[],"mappings":";AA0mBA;CACA,kBAAA;CACA,cAAA;CACA,gBAAA;AACA;AACA;CACA,oBAAA;AACA;AACA;CACA,eAAA;AACA;AACA;CACA,gBAAA;CACA,gBAAA;CACA,iBAAA;AACA;AACA;CACA,gBAAA;AACA;AACA;IACA,aAAA;AACA;AACA;CACA,iBAAA;AACA;AAEA;CACA,+BAAA;AACA;AAEA;CACA,iBAAA;AACA;AAEA;CACA,cAAA;AACA;AAEA;CACA,2BAAA;AACA;AAEA;CACA,eAAA;AACA;AAEA;CACA,aAAA;AACA;AAEA;CACA,cAAA;AACA;AACA;CACA,qCAAA;AACA;AAEA;CACA,qBAAA;IACA,0DAAA;AACA;AAEA;CACA,aAAA;AACA;AAEA;CACA,8BAAA;AACA;AAEA;CACA,cAAA;AACA;AAEA;CACA,eAAA;AACA;AAEA;CACA,yBAAA;AACA;AAEA;CACA,WAAA;AACA;AAEA;CACA,iBAAA;IACA,YAAA;AACA;AACA;IACA,uBAAA;AACA;AACA;CACA,4BAAA;IACA,gCAAA;AACA;AACA;CACA,+BAAA;AACA;AACA;CACA,kBAAA;AACA;AACA;EACA,yBAAA;AACA","file":"add-property-widget.vue","sourcesContent":["<template>\r\n\t<div class=\"add_property_widget pb-5\">\r\n\t\t<full_loading></full_loading>\r\n\t\t<div v-if=\"ready\">\r\n\t\t\t<div v-if=\"edit_property == null && parent_property.ad_type=='' && parent_property.property_type==''\">\r\n\t\t\t\t<template v-if=\"!mashro\">\r\n\t\t\t\t\t<div class=\"form-group text-center\" v-if=\"permitted_agencies.length > 0\">\r\n\t\t\t\t\t\t<label>{{\r\n\t\t\t\t\t\t\thelper.t(\"Advertisement belongs to whom?\")\r\n\t\t\t\t\t\t}}</label\r\n\t\t\t\t\t\t><br />\r\n\t\t\t\t\t\t<div class=\"btn-group me-2\" role=\"group\">\r\n\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\tclass=\"btn\"\r\n\t\t\t\t\t\t\t@click.prevent=\"set_for_agency(0)\"\r\n\t\t\t\t\t\t\t:class=\"\r\n\t\t\t\t\t\t\t\t!parent_property.for_agency\r\n\t\t\t\t\t\t\t\t? 'btn-primary'\r\n\t\t\t\t\t\t\t\t: 'btn-outline-secondary'\r\n\t\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ helper.t(\"For Yourself\") }}\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\tclass=\"btn\"\r\n\t\t\t\t\t\t\t@click.prevent=\"set_for_agency(1)\"\r\n\t\t\t\t\t\t\t:class=\"\r\n\t\t\t\t\t\t\t\tparent_property.for_agency\r\n\t\t\t\t\t\t\t\t? 'btn-primary'\r\n\t\t\t\t\t\t\t\t: 'btn-outline-secondary'\r\n\t\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ helper.t(\"For Agency\") }}\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"row justify-content-center\" v-if=\"permitted_agencies.length > 1 && parent_property.for_agency\">\r\n\t\t\t\t\t\t<div class=\"col-lg-6 col-md-6\">\r\n\t\t\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t\t\t<select v-model=\"parent_property.selected_agency\" class=\"form-select form-control border-radius\" aria-label=\"Default select example\">\r\n\t\t\t\t\t\t\t\t\t<option value=\"\">{{helper.t(\"Select Agency\")}}</option>\r\n\t\t\t\t\t\t\t\t\t<option v-for=\"agency in permitted_agencies\" :value=\"agency.agency\">{{ agency.full_name }} - (0{{ agency.agency.substring(4) }})</option>\r\n\t\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</template>\r\n\t\t\t\t<h3 class=\"text-center\" v-if=\"mashro\">{{ helper.t(\"Add Unit to Project\") }}</h3>\r\n\t\t\t\t<h5 class=\"text-center\" v-if=\"mashro\">{{ mashro.title }}</h5>\r\n\t\t\t\t<div v-if=\"!is_nafath_verified && !parent_property.for_agency\" class=\"row justify-content-center\">\r\n\t\t\t\t\t<div class=\"col-lg-4 col-sm-4\">\r\n\t\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t\t<label>{{ helper.t(\"National Id / Iqama\") }}</label>\r\n\t\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t\tv-model=\"advertiser_id\"\r\n\t\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\t\tclass=\"form-control border-radius\"/>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div v-else-if=\"parent_property.selected_agency\" class=\"row justify-content-center\">\r\n\t\t\t\t\t<div class=\"col\">\r\n\t\t\t\t\t\t<h5 class=\"modal-title text-center\" id=\"staticBackdropLabel\">{{ parent_property.selected_agency_full_name }}</h5>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"row justify-content-center\">\r\n\t\t\t\t\t<div class=\"col-lg-4 col-sm-4\">\r\n\t\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t\t<label>{{\r\n\t\t\t\t\t\t\t\thelper.t(\"Ad License Number\")\r\n\t\t\t\t\t\t\t}}</label>\r\n\t\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t\tv-model=\"ad_license_number\"\r\n\t\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\t\tclass=\"form-control border-radius\"/>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"row d-flex justify-content-center\">\r\n\t\t\t\t\t<div class=\"col-lg-4 text-center\">\r\n\t\t\t\t\t\t<a class=\"btn default-btn mt-2 show-hand\" @click.prevent=\"checkAdvertisement();\">\r\n\t\t\t\t\t\t\t{{ helper.t(\"Continue\") }}\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div v-if=\"edit_property != null || (parent_property.ad_type!='' && parent_property.property_type!='')\">\r\n          \t\t<div class=\"container\">\r\n\t\t\t\t\t<div class=\"row mb-4\">\r\n\t\t\t\t\t\t<div class=\"col-6\">\r\n\t\t\t\t\t\t\t<h2 class=\"text-start\">{{ helper.t(\"{0} for \"+ parent_property.ad_type,[parent_property.property_type]) }}</h2>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"col-6 d-flex justify-content-end\">\r\n\t\t\t\t\t\t\t<a class=\"text-end show-hand mx-3\"\r\n\t\t\t\t\t\t\t\t@click=\"reupdateRegaAdvertisement();\">\r\n\t\t\t\t\t\t\t\t<i class=\"fa-solid fa-rotate fa-lg mx-1\"></i> {{ helper.t(\"Reupdate from REGA\") }}\r\n\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t<a class=\"text-end show-hand mx-3\"\r\n\t\t\t\t\t\t\t\tdata-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Full property info.')\"\r\n\t\t\t\t\t\t\t\t@click=\"showModal('#rega_info_modal');\">\r\n\t\t\t\t\t\t\t\t<i class=\"fa-solid fa-circle-info fa-lg mx-1\" ></i> {{ helper.t(\"Ad license ID: {0}\",[parent_property.ad_license_number]) }}\r\n\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<property_form\r\n\t\t\t\t\t:property = \"parent_property\"\r\n\t\t\t\t\t:is_edit = \"edit_property!=null?true:false\"\r\n\t\t\t\t></property_form>\r\n\t\t\t</div>\r\n\t\t\t<div v-if=\"parent_property.ad_type != '' && parent_property.property_type != ''\" class=\"col-lg-12 text-center mt-20\">\r\n\t\t\t\t<button @click.prevent=\"load_agreement();\" type=\"submit\" class=\"btn default-btn\">{{ helper.t('Continue') }}</button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<!-- Modal -->\r\n\t\t<div class=\"modal fade filter-popup-area\" id=\"save_dialog\" data-bs-keyboard=\"false\" tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\r\n\t\t\t<div class=\"modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-header\">\r\n\t\t\t\t\t\t<h5 class=\"modal-title\" id=\"staticBackdropLabel\">{{ helper.t(!agreement?\"Details\":\"Agreement\") }}</h5>\r\n\t\t\t\t\t\t<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"modal-body\">\r\n\t\t\t\t\t\t<div class=\"row\" v-if=\"edit_property == null && !agreement\">\r\n\t\t\t\t\t\t\t<div class=\"col\">\r\n\t\t\t\t\t\t\t\t<div class=\"form-group mb-3\">\r\n\t\t\t\t\t\t\t\t\t<label class=\"toggler\" id=\"filt-yearly\">{{ helper.t(\"Advertising as\") }}</label>\r\n\t\t\t\t\t\t\t\t\t<div class=\"btn-toolbar\" role=\"toolbar\" aria-label=\"Toolbar with button groups\">\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"btn-group me-2\" role=\"group\">\r\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t@click.prevent=\"parent_property.creator_type='Owner';parent_property.for_agency=false;\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t:class=\"parent_property.creator_type=='Owner'?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"As an Owner\") }}</button>\r\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t@click.prevent=\"parent_property.creator_type='Agent';parent_property.for_agency=false;\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t:class=\"parent_property.creator_type=='Agent'?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"As an Agent\") }}</button>\r\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t@click.prevent=\"parent_property.creator_type='Advertiser';parent_property.for_agency=false;\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t:class=\"parent_property.creator_type=='Advertiser'?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"As an Advertiser\") }}</button>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"row\" v-if=\"edit_property == null && permitted_agencies.length > 0 && !agreement && (['Owner','Advertiser'].includes(parent_property.creator_type))\">\r\n\t\t\t\t\t\t\t<div class=\"col\">\r\n\t\t\t\t\t\t\t\t<div class=\"form-group mb-3\">\r\n\t\t\t\t\t\t\t\t\t<label class=\"toggler\" id=\"filt-yearly\">{{ helper.t(\"Advertising For\") }}</label>\r\n\t\t\t\t\t\t\t\t\t<div class=\"btn-toolbar\" role=\"toolbar\" aria-label=\"Toolbar with button groups\">\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"btn-group me-2\" role=\"group\">\r\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t@click.prevent=\"parent_property.for_agency=0;\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t:class=\"!parent_property.for_agency?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"Not for agency\") }}</button>\r\n\t\t\t\t\t\t\t\t\t\t\t<button v-if=\"permitted_agencies.length > 0\" type=\"button\" class=\"btn\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t@click.prevent=\"parent_property.for_agency=1;\" \r\n\t\t\t\t\t\t\t\t\t\t\t\t:class=\"parent_property.for_agency?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"For agency\") }}</button>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div v-if=\"agreement\" class=\"row add-listing\">\r\n\t\t\t\t\t\t\t<div v-html=\"agreement\"\r\n\t\t\t\t\t\t\tstyle=\"padding: 10px;\r\n\t\t\t\t\t\t\tbackground: lightgrey;\r\n\t\t\t\t\t\t\tborder: 2px grey SOLID;\r\n\t\t\t\t\t\t\theight: 300px;\r\n\t\t\t\t\t\t\toverflow: auto;\"></div>\r\n\t\t\t\t\t\t\t<div class=\"features-content mt-2 text-center\">\r\n\t\t\t\t\t\t\t\t<ul class=\"d-flex justify-content-center\">\r\n\t\t\t\t\t\t\t\t\t<li role=\"button\" @click=\"policy_agreed = !policy_agreed;\">\r\n\t\t\t\t\t\t\t\t\t\t<i v-if=\"policy_agreed\" class=\"ri-checkbox-circle-fill\"></i>\r\n\t\t\t\t\t\t\t\t\t\t<i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n\t\t\t\t\t\t\t\t\t\t{{helper.t(\"I agree\")}}\r\n\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t\t\t<a  v-if=\"policy_agreed\" href=\"#\" @click.prevent=\"save_property()\" class=\"btn default-btn equalizer\">\r\n\t\t\t\t\t\t\t\t\t{{ edit_property == null?helper.t(parent_property.publish?\"Save & publish property\":\"Save & unpublish property\"):\r\n\t\t\t\t\t\t\t\t\thelper.t(parent_property.publish?\"Update & publish property\":\"Update & unpublish property\") }}\r\n\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t<template v-if=\"!agreement\">\r\n\t\t\t\t\t\t\t\t<p v-if=\"edit_property == null && !parent_property.for_agency\">{{ helper.t(\"{0} for {1} as an {2}\",[this.parent_property.property_type, this.parent_property.ad_type, parent_property.creator_type]) }}</p>\r\n\t\t\t\t\t\t\t\t<p v-else-if=\"edit_property == null && parent_property.for_agency\">{{ helper.t(\"{0} for {1} for an Agency as an {2}\",[this.parent_property.property_type, this.parent_property.ad_type, parent_property.creator_type]) }}</p>\r\n\t\t\t\t\t\t\t\t<p v-else>{{ helper.t(\"Do you want to update?\") }}</p>\r\n\t\t\t\t\t\t\t</template>\r\n\t\t\t\t\t\t\t<div class=\"col show-hand text-end\">\r\n\t\t\t\t\t\t\t\t<a v-if=\"!agreement && (!parent_property.for_agency || parent_property.selected_agency)\" class=\"btn default-btn mt-2\" @click=\"load_agreement();\">\r\n\t\t\t\t\t\t\t\t\t<p>{{ helper.t(edit_property == null?\"Continue\":\"Update\") }}</p>\r\n\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t<a class=\"btn default-btn show-hand mt-2\" @click=\"closeModal('#save_dialog');\">\r\n\t\t\t\t\t\t\t\t\t<p>{{ helper.t(\"No wait!\") }}</p>\r\n\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- Modal -->\r\n\t\t<!-- Modal -->\r\n\t\t<div class=\"modal fade filter-popup-area\" id=\"rega_info_modal\" data-bs-keyboard=\"false\" tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\r\n\t\t\t<div class=\"modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-header\">\r\n\t\t\t\t\t\t<h5 class=\"modal-title\" id=\"staticBackdropLabel\">{{ helper.t(\"Full property info.\") }}</h5>\r\n\t\t\t\t\t\t<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"modal-body\">\r\n\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t<div class=\"col\">\r\n\t\t\t\t\t\t\t\t<table class=\"table table-striped\">\r\n\t\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t\t\t<tr \r\n\t\t\t\t\t\t\t\t\t\tv-for=\"(val, atr) in parent_property.rega_data\"\r\n\t\t\t\t\t\t\t\t\t\t\tv-if=\" (val != undefined && val != null && val !== '' && atr != 'adLicenseUrl' && atr != 'adSource' && atr != 'location' && atr != 'locationDescriptionOnMOJDeed' && atr != 'propertyPrice' && atr != 'landTotalPrice' && atr != 'landTotalAnnualRent') && (borders || atr != 'borders') && (rer_borders || atr != 'rerBorders')\" \r\n\t\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t\t<td v-if=\"atr == 'propertyPrice'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<template v-if=\"parent_property.ad_type == 'Sale'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{ parent_property.property_type=='Land'?helper.t(\"Price per Square Meter\"):helper.t(\"Total Price\") }}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</template>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<template v-else>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{ parent_property.property_type=='Land'?helper.t(\"Yearly rent per Square Meter\"):helper.t(\"Yearly Rent\") }}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</template>\r\n\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td v-else>{{ helper.t(atr) }}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td v-if=\"atr=='borders' || atr=='location'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<table class=\"table table-striped table-sm text-break\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr v-for=\"(sval, satr) in val\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tv-if=\" (sval != undefined && sval != null && sval != '')\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{ helper.t(satr) }}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{ helper.t(sval) }}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td v-else-if=\"atr == 'rerBorders'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<table class=\"table table-striped table-sm table-borderless\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr v-for=\"(sval, satr) in val\" v-if=\" (sval != undefined && sval != null && sval != '')\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td><b>{{ helper.t(\"_direction\") }}: </b> {{ sval.direction }}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td><b>{{ helper.t(\"_type\") }}: </b> {{ sval.type }}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td><b>{{ helper.t(\"_length\") }}: </b> {{ sval.length }}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td v-else>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{ helper.t(val) }}\r\n\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t<div class=\"col show-hand text-end\">\r\n\t\t\t\t\t\t\t\t<a class=\"btn default-btn mt-2 show-hand\" @click=\"closeModal('#rega_info_modal');\">\r\n\t\t\t\t\t\t\t\t\t<p>{{ helper.t(\"Continue\") }}</p>\r\n\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- Modal -->\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport * as global from \"../../js/global\";\r\n\timport * as helper from \"../../js/helper\";\r\n\timport property_form from \"../components/property-form.vue\";\r\n\timport full_loading from \"../components/full-loading.vue\";\r\n\texport default{\r\n        components: {\r\n            property_form:property_form,\r\n            full_loading:full_loading,\r\n        },\r\n\t\tname:'add_property_widget',\r\n        props: {\r\n            property_json: {\r\n\t\t\t\ttype: String,\r\n            },\r\n            property_name: {\r\n\t\t\t\ttype: String,\r\n            },\r\n            mashro_json: {\r\n\t\t\t\ttype: String,\r\n            }\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n\t\t\t\tready:false,\r\n\t\t\t\tloading:false,\r\n\t\t\t\tagreement:null,\r\n                policy_agreed:false,\r\n\t\t\t\tcurrent_step: 0,\r\n\t\t\t\tparent_property: new global.Property(),\r\n\t\t\t\tchild_property:null,\r\n\t\t\t\tproperty_types:global.property_constants.property_types,\r\n\t\t\t\tpermitted_agencies:[], \r\n                edit_property: null,\r\n                mashro: null,\r\n\t\t\t\tis_nafath_verified:false,\r\n\t\t\t\tad_license_number: \"\",\r\n\t\t\t\tadvertiser_id: null,\r\n\t\t\t\tborders:false,\r\n\t\t\t\trer_borders:false,\r\n\t\t\t}\r\n\t\t},\r\n        async created(){\r\n\t\t\tif(this.property_json != undefined){\r\n                this.edit_property = JSON.parse(this.property_json);\r\n\t\t\t\tthis.parent_property.from_map(this.edit_property);\r\n\t\t\t}\r\n\t\t\tthis.parent_property.for_agency = 0;\r\n\t\t\tif(this.mashro_json != \"None\"){\r\n                this.mashro = JSON.parse(this.mashro_json);\r\n\t\t\t\tthis.parent_property.for_agency = 1;\r\n\t\t\t\tthis.parent_property.selected_agency = this.mashro.user;\r\n\t\t\t}\r\n\t\t\tawait this.initNafath();\r\n    \t\tthis.parent_property.total_price = this.parent_property.total_price.toFixed(0);\r\n        },\r\n        async mounted(){\r\n\t\t\tglobal.emitter.emit(\"show-full-loading\");\r\n\t\t\tawait this.getPermittedAgencies();\r\n\t\t\tif(this.edit_property){\r\n\t\t\t\tthis.normalizeRegaData();\r\n\t\t\t\tthis.showModal(\"#rega_info_modal\");\r\n\t\t\t}\r\n\t\t\tthis.ready = true;\r\n\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n        },\r\n\t\tmethods: {\r\n\t\t\tselect_property_type: function (selected_property_type){\r\n\t\t\t\tthis.parent_property.property_type = selected_property_type;\r\n\t\t\t\tthis.current_step = global.property_constants.property_with_child[selected_property_type]?2:3;\r\n\t\t\t},\r\n\t\t\tgetPermittedAgencies: async function () {\r\n\t\t\t\tthis.loading = true;\r\n                let params = {};\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.get_permitted_agencies\",\r\n                        type: \"GET\",\r\n                        data: params //for GET request\r\n                        // data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    this.permitted_agencies = res.message\r\n                    this.loading = false\r\n                    this.$forceUpdate();\r\n                } catch (e) {\r\n                    console.log(\"failed\");\r\n                    console.log(e);\r\n                    var exceptions = helper.showException(e);\r\n                }\r\n                \r\n                this.loading = false;\r\n\t\t\t},\r\n\t\t\tload_agreement: async function () {\r\n\t\t\t\tconsole.log(\"load_agreement\")\r\n\t\t\t\t$(\"#save_dialog\").modal('show');\r\n\t\t\t\t// if(this.edit_property){\r\n\t\t\t\t// \tthis.save_property();\r\n\t\t\t\t// \treturn;\r\n\t\t\t\t// }\r\n\t\t\t\tthis.loading = true;\r\n\t\t\t\tlet role = this.parent_property.creator_type;\r\n                let params = {\r\n\t\t\t\t\t\"role\": role\r\n\t\t\t\t};\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.get_add_property_policy\",\r\n                        type: \"GET\",\r\n                        data: params //for GET request\r\n                        // data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    this.agreement = res.message\r\n                    this.loading = false\r\n                    this.$forceUpdate();\r\n                } catch (e) {\r\n                    console.log(\"failed\");\r\n                    console.log(e);\r\n                    var exceptions = helper.showException(e);\r\n                }\r\n                \r\n                this.loading = false;\r\n\t\t\t},\r\n\t\t\tconfirm_save: async function () {\r\n\t\t\t\tif(!this.parent_property.validate()){\r\n\t\t\t\t\tbootbox.alert({\r\n\t\t\t\t\t\ttitle: helper.t(\"Error\"),\r\n\t\t\t\t\t\tmessage:`<div class=\"alert alert-danger\" role=\"alert\">\r\n\t\t\t\t\t\t\t\t\t`+helper.t(\"Please fix the issues marked in Red Color\")+`\r\n\t\t\t\t\t\t\t\t</div>`,\r\n\t\t\t\t\t\tsize: 'large',\r\n\t\t\t\t\t\tbuttons: {\r\n\t\t\t\t\t\t\tok: {\r\n\t\t\t\t\t\t\t\tlabel: helper.t(\"Ok\"),\r\n\t\t\t\t\t\t\t\tclassName: 'btn default-btn'\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t},\r\n\t\t\t\t\t\tcallback: (results) => results?this.save_property():console.log(\"cancel\"),\r\n\t\t\t\t\t});\r\n\t\t\t\t\treturn;\r\n\t\t\t\t}\r\n\t\t\t\tthis.agreement=null;\r\n\t\t\t\tthis.policy_agreed=false;\r\n\t\t\t\t$('#save_dialog').modal('show');\r\n\t\t\t},\r\n            async initNafath(){\r\n\t\t\t\tthis.is_nafath_verified = false;\r\n                global.emitter.emit(\"show-full-loading\");\r\n\t\t\t\ttry {\r\n\t\t\t\t\tlet params = {};\r\n\t\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\t\theaders: { \"X-Frappe-CSRF-Token\": frappe.csrf_token },\r\n\t\t\t\t\t\turl: \"/api/method/maalek.api.is_nafath_verified\",\r\n\t\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\t\tdata: params,\r\n\t\t\t\t\t});\r\n\t\t\t\t\tif (res.message == false) {\r\n                        this.is_nafath_verified = false;\r\n\t\t\t\t\t}else{\r\n                        this.is_nafath_verified = true;\r\n                    }\r\n\t\t\t\t} catch (error) {\r\n\t\t\t\t\tthis.exceptions = helper.showException(error);\r\n\t\t\t\t}\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            },\r\n            async checkAdvertisement(){\r\n\t\t\t\tconsole.log(\"checkAdvertisement\");\r\n                global.emitter.emit(\"show-full-loading\");\r\n\t\t\t\tif(this.ad_license_number.length != 10){\r\n\t\t\t\t\thelper.showException(\"Wrong advertisement license number\");\r\n\t\t\t\t}else{\r\n\t\t\t\t\ttry {\r\n\t\t\t\t\t\tlet params = {\r\n\t\t\t\t\t\t\t\"ad_license_number\":this.ad_license_number,\r\n\t\t\t\t\t\t\t\"advertiser_id\":this.advertiser_id,\r\n\t\t\t\t\t\t\t\"for_agency\": this.parent_property.for_agency,\r\n\t\t\t\t\t\t\t\"selected_agency\": this.parent_property.selected_agency\r\n\t\t\t\t\t\t};\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\t\t\theaders: { \"X-Frappe-CSRF-Token\": frappe.csrf_token },\r\n\t\t\t\t\t\t\turl: \"/api/method/maalek.api.check_rega_advertisement_validator\",\r\n\t\t\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\t\t\tdata: params\r\n\t\t\t\t\t\t});\r\n\t\t\t\t\t\tif (this.advertiser_id != null) {\r\n\t\t\t\t\t\t\tglobal.emitter.emit(\"set-national-id\",this.advertiser_id);\r\n\t\t\t\t\t\t\tglobal.emitter.emit(\"set-onsuccess-func\",()=>{\r\n\t\t\t\t\t\t\t\t$('#nafaz-verification-modal').modal('hide');\r\n\t\t\t\t\t\t\t\tthis.getRegaAdvertisement();\r\n\t\t\t\t\t\t\t});\r\n\t\t\t\t\t\t\t$('#nafaz-verification-modal').modal('show');\r\n\t\t\t\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n\t\t\t\t\t\t}else{\r\n\t\t\t\t\t\t\tthis.getRegaAdvertisement();\r\n\t\t\t\t\t\t\treturn;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t} catch (error) {\r\n\t\t\t\t\t\tthis.exceptions = helper.showException(error);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            },\r\n            async getRegaAdvertisement(){\r\n\t\t\t\tconsole.log(\"getRegaAdvertisement\");\r\n                global.emitter.emit(\"show-full-loading\");\r\n\t\t\t\ttry {\r\n\t\t\t\t\tlet params = {\r\n\t\t\t\t\t\t\"ad_license_number\":this.ad_license_number,\r\n\t\t\t\t\t\t\"for_agency\": this.parent_property.for_agency,\r\n\t\t\t\t\t\t\"selected_agency\": this.parent_property.selected_agency,\r\n\t\t\t\t\t};\r\n\t\t\t\t\t\t\r\n\t\t\t\t\tif(this.mashro != null){\r\n\t\t\t\t\t\tparams[\"selected_mashro\"] = this.mashro.name\r\n\t\t\t\t\t}\r\n\t\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\t\theaders: { \"X-Frappe-CSRF-Token\": frappe.csrf_token },\r\n\t\t\t\t\t\turl: \"/api/method/maalek.api.rega_advertisement_validator\",\r\n\t\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\t\tdata: params\r\n\t\t\t\t\t});\r\n\t\t\t\t\tthis.parent_property.name = res.message.name;\r\n\t\t\t\t\tthis.parent_property.ad_type = res.message.ad_type;\r\n\t\t\t\t\tthis.parent_property.property_type = res.message.property_type;\r\n\t\t\t\t\tthis.parent_property.size = res.message.size;\r\n\t\t\t\t\tthis.parent_property.lat = res.message.lat;\r\n\t\t\t\t\tthis.parent_property.lng = res.message.lng;\r\n\t\t\t\t\tthis.parent_property.price_sqr_meter = res.message.price_sqr_meter;\r\n\t\t\t\t\tthis.parent_property.total_price = res.message.total_price;\r\n\t\t\t\t\tthis.parent_property.ad_license_number = res.message.ad_license_number;\r\n\t\t\t\t\tthis.parent_property.rega_data = JSON.parse(res.message.rega_data);\r\n\t\t\t\t\tthis.parent_property.creator_type = res.message.creator_type;\r\n\t\t\t\t\tthis.normalizeRegaData();\r\n\t\t\t\t\tthis.showModal(\"#rega_info_modal\");\r\n\t\t\t\t} catch (error) {\r\n\t\t\t\t\tthis.exceptions = helper.showException(error);\r\n\t\t\t\t}\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            },\r\n\t\t\tnormalizeRegaData(){\r\n\t\t\t\tthis.borders = false;\r\n\t\t\t\tthis.rer_borders = false;\r\n\t\t\t\tfor (const key in this.parent_property.rega_data[\"borders\"]) {\r\n\t\t\t\t\tif(this.parent_property.rega_data[\"borders\"][key] != null && this.parent_property.rega_data[\"borders\"][key] != \"\"){\r\n\t\t\t\t\t\tthis.borders = true;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\tif(this.parent_property.rega_data[\"rerBorders\"].length > 0){\r\n\t\t\t\t\tthis.rer_borders = true;\r\n\t\t\t\t}\r\n\t\t\t},\r\n            async reupdateRegaAdvertisement(){\r\n                global.emitter.emit(\"show-full-loading\");\r\n\t\t\t\ttry {\r\n\t\t\t\t\tlet params = {\r\n\t\t\t\t\t\t\"property_name\":this.parent_property.name,\r\n\t\t\t\t\t};\r\n\t\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\t\theaders: { \"X-Frappe-CSRF-Token\": frappe.csrf_token },\r\n\t\t\t\t\t\turl: \"/api/method/maalek.api.reupdate_rega_advertisement\",\r\n\t\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\t\tdata: params\r\n\t\t\t\t\t});\r\n\t\t\t\t\tthis.parent_property.lat = res.message.lat;\r\n\t\t\t\t\tthis.parent_property.lng = res.message.lng;\r\n\t\t\t\t\tthis.parent_property.size = res.message.size;\r\n\t\t\t\t\tthis.parent_property.price_sqr_meter = res.message.price_sqr_meter;\r\n\t\t\t\t\tthis.parent_property.total_price = res.message.total_price;\r\n\t\t\t\t\tthis.parent_property.rega_data = JSON.parse(res.message.rega_data);\r\n\t\t\t\t\tthis.normalizeRegaData();\r\n\t\t\t\t\tthis.showModal(\"#rega_info_modal\");\r\n\t\t\t\t} catch (error) {\r\n\t\t\t\t\tthis.exceptions = helper.showException(error);\r\n\t\t\t\t}\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            },\r\n\t\t\tupload_files: async function(docname){\r\n\t\t\t\treturn frappe.run_serially(\r\n\t\t\t\t\tthis.parent_property.images.map(\r\n\t\t\t\t\t\t(image, i) =>\r\n\t\t\t\t\t\t\t() => helper.upload_file(image.file, i,\"Property Detail\",docname)\r\n\t\t\t\t\t)\r\n\t\t\t\t);\r\n\t\t\t},\r\n\t\t\tsave_property: async function(){\r\n\t\t\t\ttry {\r\n\t\t\t\t\tglobal.emitter.emit(\"show-full-loading\");\r\n\t\t\t\t\tlet params = this.parent_property;\r\n\t\t\t\t\tif( !Object.keys(global.property_constants.property_with_child).includes(this.property_type) ){\r\n\t\t\t\t\t\tconsole.log(\"clear floors\")\r\n\t\t\t\t\t\tthis.parent_property.floors = [];\r\n\t\t\t\t\t}else{\r\n\t\t\t\t\t\tconsole.log(\"keep floors\")\r\n\t\t\t\t\t}\r\n\t\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\t\theaders: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n\t\t\t\t\t\turl: \"/api/method/maalek.api.add_property\",\r\n\t\t\t\t\t\ttype: \"POST\",\r\n\t\t\t\t\t\tdata: JSON.stringify(params)\r\n\t\t\t\t\t});\r\n\t\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n                    helper.showSuccess(\"Property Saved\",()=>{\r\n\t\t\t\t\tlocation.replace(\"/account/my-properties\");\r\n\t\t\t\t\t});\r\n\t\t\t\t} catch (e) {\r\n\t\t\t\t\tconsole.log(e);\r\n\t\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n                    var exceptions = helper.showException(e);\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tshowModal: function(elementID){\r\n\t\t\t\t$(elementID).modal('show');\r\n\t\t\t},\r\n\t\t\tcloseModal: function(elementID){\r\n\t\t\t\t$(elementID).modal('hide');\r\n\t\t\t},\r\n\t\t\tset_for_agency: function(val){\r\n\t\t\t\tthis.parent_property.for_agency = val;\r\n\t\t\t\tif(this.parent_property.for_agency && this.permitted_agencies.length == 1){\r\n\t\t\t\t\tthis.parent_property.selected_agency = this.permitted_agencies[0].agency;\r\n\t\t\t\t\tthis.parent_property.selected_agency_full_name = this.permitted_agencies[0].full_name;\r\n\t\t\t\t}else if(!this.parent_property.for_agency){\r\n\t\t\t\t\tthis.parent_property.selected_agency = \"\";\r\n\t\t\t\t\tthis.parent_property.selected_agency_full_name = \"\";\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t},\r\n\t\tcomputed:{\r\n\t\t\tsave_btn_text(){\r\n\t\t\t\tif(this.parent_property.publish)\r\n\t\t\t\t\treturn \"Save & Publish Property\"\r\n\t\t\t\treturn \"Save & Unpublish Property\"\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n#app {\r\n\ttext-align: center;\r\n\tcolor: #2c3e50;\r\n\tmargin-top: 60px;\r\n}\r\n.single-pricing .default-btn{\r\n\tmargin-bottom: unset;\r\n}\r\n.features-content ul *{\r\n\tcursor: pointer;\r\n}\r\n.pricing-switch{\r\n\tmargin-bottom: 0;\r\n\tmargin-top: 10px;\r\n\ttext-align: start;\r\n}\r\n.pricing-switch .toggler{\r\n\tmargin-top: 10px;\r\n}\r\n.accordion-item .accordion-body ul li::before {\r\n    display: none;\r\n}\r\n.features-content *{\r\n\tuser-select: none;\r\n}\r\n\r\n.floor-table{\r\n\tborder-right: SOLID 2px #014116;\r\n}\r\n\r\n.floor-table h3{\r\n\tfont-size: 1.2rem;\r\n}\r\n\r\n.floor-table .actions *{\r\n\tcolor: #014116;\r\n}\r\n\r\n.floor-row:hover{\r\n\tbackground-color: aliceblue;\r\n}\r\n\r\n.show-on-hover, .show-on-hover-child{\r\n\tcursor: pointer;\r\n}\r\n\r\n.floor-row .show-on-hover{\r\n\tdisplay: none;\r\n}\r\n\r\n.floor-row:hover .show-on-hover{\r\n\tdisplay: block;\r\n}\r\n.property-div{\r\n\tborder-bottom: SOLID 1px antiquewhite;\r\n}\r\n\r\n.property-div.error{\r\n\tborder: SOLID 1px red;\r\n    background-color: rgba(255, 0, 0, 0.1215686275) !important;\r\n}\r\n\r\n.property-div .show-on-hover-child{\r\n\tdisplay: none;\r\n}\r\n\r\n.property-div:hover{\r\n\tbackground-color: antiquewhite;\r\n}\r\n\r\n.property-div:hover .show-on-hover-child{\r\n\tdisplay: block;\r\n}\r\n\r\n.tags{\r\n\tcursor: pointer;\r\n}\r\n\r\n.tags:hover{\r\n\tbackground-color: #014116;\r\n}\r\n\r\n.tags:hover *{\r\n\tcolor: #fff;\r\n}\r\n\r\n.tags span{\r\n\tborder: SOLID 2px;\r\n    padding: 5px;\r\n}\r\n.tags ul{\r\n    padding: 5px !important;\r\n}\r\n.tags ul li{\r\n\tpadding-left: 5px !important;\r\n    display: inline-block !important;\r\n}\r\n.modal-dialog{\r\n\t/* max-width: 70% !important; */\r\n}\r\n.add_property_widget{\r\n\tposition: relative;\r\n}\r\n.modal-content {\r\n  overflow: auto !important;\r\n}\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/add-property-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__